<template>

    <ThemeChanger :to="Theme.Dark">

        <Container fluid class="pt-16 md:pt-48 sm:pb-16 font-body">

            <AOS type="fade" easing="ease" duration="400">

                <ContactHeader
                    v-if="!isContactPage" v-aos-anchor:footer-title
                    class="mb-20 md:mb-48"
                    :heading="cms.heading"
                    :label="cms.contact_us_label"
                    :route="Route.Contact"/>

            </AOS>

            <Grid fluid>

                <AOS :order="1" anchor="footer-title" anchor-placement="top-center" :step="150">

                    <Column :span="2" class="footer__box --side">

                        <div class="footer__box__content">

                            <Anchor underlined show-arrow :route="Route.WhatWeDo">

                                <h3 v-html="cms.sub_heading_1"/>

                            </Anchor>

                            <Paragraph class="mt-12 md:pr-8" v-html="cms.sub_paragraph_1"/>

                        </div>

                    </Column>

                </AOS>

                <AOS :order="2" anchor="footer-title" anchor-placement="top-center" :step="150">

                    <Column :span="2" class="footer__box --middle">

                        <div class="footer__box__content">

                            <Anchor underlined show-arrow :route="Route.About">

                                <h3 v-html="cms.sub_heading_2"/>

                            </Anchor>

                            <Paragraph class="mt-12 md:pr-8" v-html="cms.sub_paragraph_2"/>

                        </div>

                    </Column>

                </AOS>

                <AOS :order="2" anchor="footer-title" anchor-placement="top-center" :step="150">

                    <Column :span="2" class="footer__box --side">

                        <div class="footer__box__content">

                            <Anchor underlined show-arrow :route="Route.Contact">

                                <h3 v-html="cms.sub_heading_3"/>

                            </Anchor>

                            <Paragraph class="mt-12 md:pr-8" v-html="cms.sub_paragraph_3"/>

                            <!-- <Anchor underlined class="mt-12" telephone :route="cms.phone">

                                {{ cms.display_phone }}

                            </Anchor> -->

                            <div>

                            <Anchor underlined class="mt-4" mail-to :route="cms.email">

                                {{ cms.email }}

                            </Anchor>

                            </div>

                        </div>

                    </Column>

                </AOS>

            </Grid>

            <Grid fluid>

                <Column class="footer__social" container>

                    <div class="w-full flex sm:flex-col sm:items-center md:justify-between md:items-center">

                        <div class="flex h-full sm:w-full">

                            <SocialMediaButton v-for="(social, index) of socialMedia"
                                               :key="index"
                                               v-bind="social"
                                               class="footer__social__icon"
                                               large/>

                        </div>

                        <Paragraph class="text-2xs md:text-xs sm:pt-12 sm:text-center text-gray-300 md:mr-14">

                            Digital Creative Asia 墨山网络科技（上海）有限公司

                            <span class="sm:hidden">/</span>
                            <br class="md:hidden">

                            沪ICP备19005446号-1

                        </Paragraph>

                    </div>

                </Column>

            </Grid>

        </Container>

    </ThemeChanger>

</template>

<script lang="ts">

    import { computed, defineComponent } from 'vue'
    import Anchor from './Anchor.vue'
    import Container from './Container.vue'
    import ThemeChanger from './ThemeChanger.vue'
    import ContactHeader from './ContactHeader.vue'
    import SocialMediaButton from './SocialMediaButton.vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Paragraph from './Paragraph.vue'
    import { useCms } from '../compositions/UseCms'
    import { Route } from '../enums/Route'
    import { Theme } from '../enums/Theme'
    import { useRoute } from 'vue-router'

    export default defineComponent({
        name: 'Footer',
        components: {
            ContactHeader,
            Container,
            Anchor,
            Paragraph,
            Grid,
            Column,
            SocialMediaButton,
            ThemeChanger
        },
        setup() {

            const route = useRoute()
            const { footer } = useCms()

            return {
                Route,
                Theme,
                cms: footer,
                isContactPage: computed(() => route.name === Route.Contact),
                socialMedia: [
                    {
                        name: 'LinkedIn',
                        link: 'https://linkedin.com/company/digital-creative-asia/'
                    },
                    {
                        name: 'Instagram',
                        link: 'https://instagram.com/dc.asia'
                    }
                ]
            }

        }
    })

</script>

<style lang="scss">

    @include component(footer) {

        @include part(box) {

            border-top: solid black 1px;

            @apply flex justify-center items-center;

            @screen sm {

                @apply py-16 px-10;

            }

            @screen md {

                height: 400px;
                height: 660px;
                border-bottom: solid black 1px;

            }

            @include option(middle) {

                @screen md {

                    border-right: solid black 1px;
                    border-left: solid black 1px;

                }

            }

            @include part(content) {

                @screen md {

                    width: 315px;
                    height: 300px;

                }

            }

        }

        @include part(social) {

            @screen sm {

                height: 180px;
                border-top: 1px solid #000;

            }

            @screen md {

                height: 100px;

            }

            @include part(icon) {

                @apply flex items-center;

                border-right: 1px solid #000;

                @screen sm {

                    @apply flex-1;

                    border-bottom: 1px solid #000;

                    &:last-child {

                        border-right: none;

                    }

                }

            }

        }

    }

</style>
